export enum DIDState {
  UNRESOLVED,
  RESOLVING,
  RESOLVED,
  CAN_NOT_RESOLVE,
  // TODO: this state has not been implemented yet
  ERROR,
}